/// <reference types="vite-plugin-svgr/client" />

import Feather from './Feather.svg?react';
import Fish from './Fish.svg?react';
import Image from './Image.svg?react';
import Pin from './Pin.svg?react';
import Plant from './Plant.svg?react';
import Shield from './Shield.svg?react';
import Store from './Store.svg?react';
import Trophy from './Trophy.svg?react';
import Unknown from './Unknown.svg?react';
import Vials from './Vials.svg?react';

export const icons_new = {
  Feather,
  Fish,
  Image,
  Pin,
  Plant,
  Shield,
  Store,
  Trophy,
  Unknown,
  Vials,
};
